exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quiz-actions {\n  text-align: right;\n}\n.quiz-actions.fixed {\n  position: fixed;\n  bottom: 90px;\n  right: 60px;\n}\n@media (max-width: 768px) {\n.quiz-actions.fixed {\n    bottom: 33px;\n    right: initial;\n    left: 50%;\n    transform: translateX(-60%);\n}\n}", ""]);

// exports
